import { render, staticRenderFns } from "./PhaseRewardSection.vue?vue&type=template&id=9263446a&"
import script from "./PhaseRewardSection.vue?vue&type=script&lang=js&"
export * from "./PhaseRewardSection.vue?vue&type=script&lang=js&"
import style0 from "./PhaseRewardSection.vue?vue&type=style&index=0&id=9263446a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports